export const categories = [
  {
    slug: 'dianshi',
    name: '电视剧',
    icon: 'ri-tv-line',
    description: '热门电视剧、经典剧集、最新上线的精彩电视剧内容，涵盖国产剧、韩剧、美剧等多种类型',
    count: 1256,
  },
  {
    slug: 'dianying',
    name: '电影',
    icon: 'ri-film-line',
    description: '院线大片、经典电影、高分推荐，动作片、喜剧片、爱情片、科幻片等类型丰富',
    count: 2341,
  },
  {
    slug: 'zongyi',
    name: '综艺',
    icon: 'ri-emotion-laugh-line',
    description: '热门综艺节目、真人秀、脱口秀、音乐竞演，让你笑不停、乐不够',
    count: 892,
  },
  {
    slug: 'dongman',
    name: '动漫',
    icon: 'ri-ghost-line',
    description: '热血动漫、治愈番剧、经典国漫、最新日漫，二次元爱好者的天堂',
    count: 1567,
  },
  {
    slug: 'jilu',
    name: '纪录片',
    icon: 'ri-earth-line',
    description: '自然探索、人文历史、科技前沿、美食之旅，用镜头记录世界的精彩',
    count: 456,
  },
  {
    slug: 'yule',
    name: '娱乐资讯',
    icon: 'ri-newspaper-line',
    description: '最新娱乐八卦、明星动态、影视资讯、行业新闻，娱乐前沿一手掌握',
    count: 2134,
  },
];

export const getCategoryBySlug = (slug: string) => {
  return categories.find((c) => c.slug === slug) || categories[0];
};